import { ICONS } from '~/constants/icons';
import { getPlotSize } from '@habity/services';
import { DataFieldConfig, forEstateTypes } from './data-builder';

export const buildingFields: DataFieldConfig[] = [

  {
    key: 'building.buildingType',
    label: 'Byggnadstyp',
    icon: ICONS.BUILDING.CATEGORY,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.buildingYear',
    label: 'Byggår',
    icon: ICONS.BUILDING.YEAR,
    // estateTypes: forEstateTypes('House', 'Cottage'),
    formatter: (value, context) => {
      const commentary = context?.filteredProviderData?.building?.commentaryForBuildingYear;
      return commentary ? `${value} (${commentary})` : value;
    },
  },

 

  {
    key: 'building.facade',
    label: 'Fasad',
    icon: ICONS.BUILDING.FACADE,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.frame',
    label: 'Stomme',
    icon: ICONS.BUILDING.FRAME,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.windows',
    label: 'Fönster',
    icon: ICONS.BUILDING.WINDOWS,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.beam',
    label: 'Bjälklag',
    icon: ICONS.BUILDING.BEAM,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.externallySheetMetalWork',
    label: 'Yttertak- och plåtarbeten',
    icon: ICONS.BUILDING.EXTERNALLY_SHEET_METAL_WORK,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.foundationWall',
    label: 'Grundmur',
    icon: ICONS.BUILDING.FOUNDATION_WALL,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.roof',
    label: 'Tak',
    icon: ICONS.BUILDING.ROOF,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.foundation',
    label: 'Grund',
    icon: ICONS.BUILDING.FOUNDATION,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.heating',
    label: 'Uppvärmning',
    icon: ICONS.BUILDING.HEATING,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'waterAndDrain.info',
    label: 'Vatten och avlopp',
    icon: ICONS.BUILDING.WATER,
    estateTypes: forEstateTypes('House', 'Cottage', 'Farm', 'Condominium', 'CommercialProperty', 'HousingCooperative'),
  },

  {
    key: 'ventilation.type',
    label: 'Ventilation',
    icon: ICONS.BUILDING.VENTILATION,
    // estateTypes: forEstateTypes('House', 'Cottage'),
  },

  // Plot information
  {
    key: 'plot.otherPlot',
    label: 'Tomtbeskrivning',
    icon: ICONS.BUILDING.PLOT_SIZE,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'plot.area',
    label: 'Tomtstorlek',
    icon: ICONS.BUILDING.PLOT_SIZE,
    estateTypes: forEstateTypes('House', 'Cottage'),
    formatter: (value) => getPlotSize(value, false),
  },

  {
    key: 'plot.plotType',
    label: 'Tomttyp',
    icon: ICONS.BUILDING.PLOT_TYPE,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'plot.patio',
    label: 'Uteplats',
    icon: ICONS.BUILDING.PLOT_PATIO,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'plot.buildingPermission',
    label: 'Bygglov',
    icon: ICONS.BUILDING.PLOT_BUILDING_PERMISSION,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'plot.parking',
    label: 'Parkering',
    icon: ICONS.BUILDING.PLOT_PARKING,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'building.otherBuildings',
    label: 'Övriga byggnader',
    icon: ICONS.BUILDING.OTHER_BUILDINGS,
    estateTypes: forEstateTypes('House', 'Cottage'),
  },

  {
    key: 'floorAndElevator.elevator',
    label: 'Hiss',
    icon: ICONS.BUILDING.ELEVATOR,
    estateTypes: forEstateTypes('HousingCooperative'),
    formatter: (value, context) => {
      const description = context?.filteredProviderData?.floorAndElevator?.descriptionOfElevator;
      return `${value}${description ? ` (${description})` : ''}`;
    },
  },

  {
    key: 'association.tvAndBroadband',
    label: 'TV och bredband',
    icon: ICONS.BUILDING.TV,
    estateTypes: forEstateTypes('HousingCooperative'),
  },

  {
    key: 'tvAndBroadband.tv',
    label: 'TV',
    icon: ICONS.BUILDING.TV,
  },

  {
    key: 'tvAndBroadband.broadband',
    label: 'Bredband',
    icon: ICONS.BUILDING.INTERNET,
  },


  




  // Main residential building
  {
    key: 'mainResidentialBuilding.buildingType',
    label: 'Byggnadstyp',
    icon: ICONS.BUILDING.CATEGORY,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.yearBuilt',
    label: 'Byggår',
    icon: ICONS.BUILDING.YEAR,
    estateTypes: forEstateTypes('Farm'),
    formatter: (value, context) => {
      const commentary = context?.filteredProviderData?.mainResidentialBuilding?.building?.commentaryForBuildingYear;
      return commentary ? `${value} (${commentary})` : value;
    },
  },

  {
    key: 'mainResidentialBuilding.building.facade',
    label: 'Fasad',
    icon: ICONS.BUILDING.FACADE,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.frame',
    label: 'Stomme',
    icon: ICONS.BUILDING.FRAME,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.windows',
    label: 'Fönster',
    icon: ICONS.BUILDING.WINDOWS,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.beam',
    label: 'Bjälklag',
    icon: ICONS.BUILDING.BEAM,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.externallyMetalWork',
    label: 'Yttertak- och plåtarbeten',
    icon: ICONS.BUILDING.EXTERNALLY_SHEET_METAL_WORK,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.foundationWall',
    label: 'Grundmur',
    icon: ICONS.BUILDING.FOUNDATION_WALL,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.roof',
    label: 'Tak',
    icon: ICONS.BUILDING.ROOF,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.foundation',
    label: 'Grund',
    icon: ICONS.BUILDING.FOUNDATION,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.heating',
    label: 'Uppvärmning',
    icon: ICONS.BUILDING.HEATING,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.building.waterAndDrain',
    label: 'Vatten och avlopp',
    icon: ICONS.BUILDING.WATER,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.ventilation.type',
    label: 'Ventilation',
    icon: ICONS.BUILDING.VENTILATION,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.energyDeclaration.primaryEnergyNumber',
    label: 'Energiprestanda',
    formatter: (value) => `${value} kWh/kvm och år`,
    icon: ICONS.BUILDING.ENERGY_CONSUMPTION,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.energyDeclaration.energyClass',
    label: 'Energiklass',
    icon: ICONS.BUILDING.ENERGY_CLASSIFICATION,
    estateTypes: forEstateTypes('Farm'),
  },

    {
    key: 'mainResidentialBuilding.tvAndBroadband.tv',
    label: 'TV',
    icon: ICONS.BUILDING.TV,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.tvAndBroadband.broadband',
    label: 'Bredband',
    icon: ICONS.BUILDING.INTERNET,
    estateTypes: forEstateTypes('Farm'),
  },
 

  {
    key: 'mainResidentialBuilding.parkingSpace',
    label: 'Parkering',
    icon: ICONS.BUILDING.PLOT_PARKING,
    estateTypes: forEstateTypes('Farm'),
  },
  {
    key: 'mainResidentialBuilding.sideBuildings',
    label: 'Övriga byggnader',
    icon: ICONS.BUILDING.OTHER_BUILDINGS,
    estateTypes: forEstateTypes('Farm'),
  },

 {
    key: 'mainResidentialBuilding.plot',
    label: 'Tomt',
    icon: ICONS.BUILDING.PLOT_SIZE,
    estateTypes: forEstateTypes('Farm'),
  },

  {
    key: 'mainResidentialBuilding.patio',
    label: 'Uteplats',
    icon: ICONS.BUILDING.PLOT_PATIO,
    estateTypes: forEstateTypes('Farm'),
  },

];
